import React from 'react';
import { useTranslation } from 'react-i18next';

const VersionDisplay = () => {
  const version = process.env.REACT_APP_VERSION;
  const [t,] = useTranslation('global');

  return (
    <div className='version-container'>
      <p>{t('version')}: {version}</p>
    </div>
  );
};

export default VersionDisplay;